import { PropsWithChildren } from "react";
import { Section } from "../../hooks/configurator/types";
import { BaseVariantSwitcher } from "./custom/BaseVariantSwitcher";
import { PaintSelection } from "./custom/PaintSelection";
import {RoofControl} from "./custom/RoofControl";

export interface ConfiguratorSectionProps extends PropsWithChildren {
  section: Section;
}

export function renderCustomComponent(
  name: string,
  props: ConfiguratorSectionProps
) {
  switch (name) {
    case "BaseVariantSwitcher":
      return <BaseVariantSwitcher {...props} />;
    case "PaintSelection":
      return <PaintSelection {...props} />;
    case "RoofControl":
      return <RoofControl {...props} />;
    default:
      return null;
  }
}
